import {
  ChangeDetectorRef,
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  EventEmitter,
  Output,
  AfterViewInit,
  OnDestroy,
  OnChanges,
} from "@angular/core";
import { CartService } from "../../services/cart.service";
import { Cart } from "../../model/cart";
import { SnackBarService } from "../../services/snack-bar.service";
import { DtmService } from "../../../services/dtm.service";
import { SessionStorageService } from "src/app/shared/services/session-storage.service";
import { errorMapping } from "../../constants/errors";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { CustomerService } from "../../services/customer.service";
import { Customer } from "../../model/customer";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { DiscountModalService } from "../../services/discount-modal.service";
import { LoadingService } from "../../services/loading.service";
import { Subscription } from "rxjs";
import { UtilsService } from "../../services/utils.service";

@Component({
    // tslint:disable-next-line: component-selector
    selector: "pme-cart",
    templateUrl: "./cart.component.html",
    styleUrls: ["./cart.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CartComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @Input() isUpgrade: boolean;
  @Input() newPayment: boolean;
  @Input() paymentFormSubmitting: boolean;
  @Input() redirectUrl: string;
  @Input() installmentSelected: any;
  @Output() allowAutomaticRechargeChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cartUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();

  automaticRechargeFormControl = new UntypedFormControl();

  cart: Cart;
  productIdentifier: string;

  installments: any;

  isBankBillet: boolean;
  isPix: boolean;

  currentPaymentMethod: string;
  lastPaymentOption: string;
  isFocused: boolean = false;
  theresValue: boolean = false;
  submittingCouponCode = false;
  couponAppliedManually = false;
  isAplicarButton;
  couponIsInvalid = null;
  couponIdentifier = "";
  couponError = "";

  cartErrors: Array<string> = [];
  cartErrorShown: boolean = false;
  additionalData: any;

  couponFb: UntypedFormGroup;
  allowAutomaticRecharge: boolean;
  lastAutomaticRechargeValue: boolean = true;
  invalidCoupon: boolean;

  showAutomaticRechargeOnlyMessage: boolean;

  classificationIdentifier: string;
  returnToShopWindowText: string = "Alterar plano";

  showFormularyCoupon: boolean = true;


  // Cupons	
  extraBalanceCoupon: any;
  extraBalanceSum: number = 0;
  appliedCoupons: any = [];
  trialCoupon: any = null;
  filteredCoupons: any;

  // Subscribers	
  automaticRechargeSubscriber: Subscription;

  verifyCoupon = (el) => el.type === 'EXTRA_BALANCE';

  constructor(
    public cartService: CartService,
    private customerService: CustomerService,
    private sessionStorageService: SessionStorageService,
    private changeDetectorRef: ChangeDetectorRef,
    private snackBarService: SnackBarService,
    public dtmService: DtmService,
    public formBuilder: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private discountModalService: DiscountModalService,
    private loading: LoadingService,
    private utils: UtilsService
  ) {
    this.productIdentifier = sessionStorage.getItem("product");

    if (sessionStorage.getItem("isAplicarButton") && sessionStorage.getItem("isAplicarButton") === "true" && sessionStorageService.getCoupon()) {
      this.isAplicarButton = true;
    } else {
      this.isAplicarButton = false;
    }

    if (sessionStorageService.getCoupon() && this.couponIdentifier === "") {
      this.couponIdentifier = sessionStorageService.getCoupon();
    }

    this.couponFb = this.formBuilder.group({
      couponIdentifier: [""]
    });
  }

  ngOnInit() {

    // Listener para quando é alterado a recarga automática no formulário de pagamento	
    this.automaticRechargeSubscriber = this.cartService.allowAutomaticRechargeChange.subscribe((e) => {
      let event = e.event;
      let autoToggle = e.autoToggle;
      this.onAutomaticRechargeClick(event, autoToggle);
    });

    // Listener para quando é alterado a forma de pagamento selecionada nos formulários de pagamento
    this.cartService.paymentMethodChanged.subscribe((event) => {
      this.isBankBillet = event === 'BANK_BILLET';
    });
    this.cartService.paymentMethodChanged.subscribe((event) => {
      this.isPix = event === 'PIX';
    });

    // Booleano para tratar diversas informações do html
    this.isBankBillet = (this.currentPaymentMethod && this.currentPaymentMethod === 'BANK_BILLET') ||
      (this.cart && this.cart.paymentMethod && this.cart.paymentMethod.identifier === 'BANK_BILLET');

    this.isPix = (this.currentPaymentMethod && this.currentPaymentMethod === 'PIX') ||
      (this.cart && this.cart.paymentMethod && this.cart.paymentMethod.identifier === 'PIX');

    // Listener para tratar quando a forma de pagamento é selecionada.
    this.cartService.paymentOptionChanged.subscribe((event) => {
      this.lastPaymentOption = event;
      if (event && this.cart) {
        this.installments = this.cart.getInstallmentsByIdentifier(event);
      }
    });

    if (this.cart || this.cartService.getCurrentCart()) {

      this.update();
    }

    let customer = this.customerService.getCurrentCustomer();
    let provisioningParameters = (customer && customer.provisioningParameter) || null;
    // Seta a recarga automatica como 'true', caso o produto do carrinho
    // possua um valor configurado
    const validationData = this.sessionStorageService.getValidationData();
    const autoRechargeSS = validationData.allowAutomaticRecharge;
    const isCreditCardCart = this.cart && this.cart.paymentMethod && this.cart.paymentMethod.identifier === 'CREDIT_CARD';
    const hasAutoRechargeConfigured = this.cart && this.cart.product && this.cart.product.automaticRecharge;
    if ((!this.allowAutomaticRecharge && isCreditCardCart && hasAutoRechargeConfigured
      || (autoRechargeSS && autoRechargeSS == 'true')
      || (!this.allowAutomaticRecharge && hasAutoRechargeConfigured)) && ((provisioningParameters && provisioningParameters.businessId !== "600b2b05bb708c15e7f39d67") || !provisioningParameters)) {

      if (this.cartService.carts && this.cartService.carts.length === 1) {
        if (this.cartService.carts[0].paymentMethod.identifier === 'BANK_BILLET') {
          this.allowAutomaticRecharge = false;
        }
      } else {
        this.allowAutomaticRecharge = true;
      }
      this.allowAutomaticRechargeChange.emit(this.allowAutomaticRecharge);
    } else if (hasAutoRechargeConfigured) {
      this.allowAutomaticRecharge = false;
      this.allowAutomaticRechargeChange.emit(this.allowAutomaticRecharge);
    }

    this.additionalData = this.sessionStorageService.getAdditionalData();

    this.classificationIdentifier = sessionStorage.getItem('classificationIdentifier');

    //Caso seja "Regarga pontual", a recarga garantida não deve aparecer e automaticamente ser "false"
    //Altera também o texto do botão de voltar para a vitrine no checkout
    if (this.classificationIdentifier === "plano-mensal-recarga-pontual") {
      this.allowAutomaticRecharge = false;
      this.allowAutomaticRechargeChange.emit(this.allowAutomaticRecharge);
      this.returnToShopWindowText = "Alterar valor da recarga"
    }
    //Altera o texto do botão de voltar para a vitrine no checkout
    if (this.classificationIdentifier === "consulta-e-recuperacao-de-dividas") {
      this.returnToShopWindowText = "Alterar pacote";
    } else if (this.classificationIdentifier === "plano-mensal") {
      this.returnToShopWindowText = "Alterar plano";
    }

    this.checkForExtraBalanceCoupon();
  }
  getTotalDiscount(): number {
    let totalDiscount = 0;
    this.filteredCoupons.forEach(discount => {
      totalDiscount += discount.discountAmount;
    });

    return totalDiscount;
  }

  ngAfterViewInit() {
    this.checkForExtraBalanceCoupon();

    this.discountModalService.discountIdentifierModal.subscribe((discountIdentifier) => {
      if (discountIdentifier) {
        this.cart.couponIdentifier = discountIdentifier;
        //this.applyCoupon(false);
      }
    });
    // this.checkShowFormularyCoupon();

    this.loading.finishTask();
  }

  thereIsInputValue() {
    if (this.cart.couponIdentifier) {
      this.theresValue = true;
    } else {
      this.theresValue = false;
    }
  }

  ngOnChanges(): void {
    if (this.paymentFormSubmitting) {
      this.couponFb.controls.couponIdentifier.disable();
    } else {
      this.couponFb.controls.couponIdentifier.enable();
    }
    // this.checkShowFormularyCoupon();
  }

  ngOnDestroy(): void {
    if (this.automaticRechargeSubscriber)
      this.automaticRechargeSubscriber.unsubscribe();
  }

  applyCoupon(automaticRechargeChange: boolean) {
    //this.couponIdentifier = "";
    this.invalidCoupon = false;
    this.isAplicarButton = true;
    sessionStorage.setItem('isAplicarButton', this.isAplicarButton.toString());
    this.couponAppliedManually = true;
    this.couponIsInvalid = null;
    this.couponFb.get('couponIdentifier').setErrors(null);
    this.setCouponValidationData();
    this.updateCoupon(mapCurrentStep(), true, automaticRechargeChange);
  }

  removeCoupon() {
    this.cart.couponIdentifier = "";
    this.couponIdentifier = "";
    this.isAplicarButton = false;
    sessionStorage.setItem('isAplicarButton', this.isAplicarButton.toString());
    this.couponIsInvalid = false;
    // this.cart.validationData = null;
    sessionStorage.removeItem("coupon");
    this.couponAppliedManually = false;
    this.updateCoupon(mapCurrentStep(), true, false);
  }

  formatCoupon() {
    this.cart.couponIdentifier = this.cart.couponIdentifier
      .toUpperCase()
      .replace(/[^A-Z0-9_]/g, "");

    this.couponIdentifier = this.cart.couponIdentifier;
  }

  /**
   * Lidando com erros do form de cartão de crédito
   */
  getCartErrors(): { [key: string]: any } {
    const map: { [key: string]: string } = {};
    this.couponError = "";
    // Validando requireds
    Object.keys(this.couponFb.controls).forEach((key) => {
      const keyName = key.toString();
      map[keyName] = this.couponFb.controls[keyName].hasError("required")
        ? "Campo obrigatório"
        : null;
      //map[keyName] =
    });
    // // Validacoes específicas

    if (this.cart.couponIdentifier && this.couponIsInvalid) {
      const error = this.getCouponError();
      map.couponIdentifier = error;
      this.couponFb.get('couponIdentifier').setErrors({
        couponError: error
      });

      this.couponError = error;

      this.cartErrorShown = true;
    }
    return map;
  }

  getCouponError(): string {
    let validCartCoupons = 0;
    let validPaymentMethods = [];

    this.cartService.carts.forEach(cart => {
      let isValid = cart.couponIdentifier && cart.appliedDiscounts.length > 0 && cart.appliedDiscounts.some(discount => discount.identifier === cart.couponIdentifier);

      if (isValid) {
        validCartCoupons += 1;
        validPaymentMethods.push(cart.paymentMethod);
      }
    });

    if (validCartCoupons === 0) {
      return 'Cupom inserido é inválido';
    } else {
      let errorPaymentMethodString = "";

      validPaymentMethods.forEach(paymentMethod => {
        if (errorPaymentMethodString === "") {
          if (paymentMethod.name === "Cartão de crédito_ADYEN") {
            errorPaymentMethodString += "cartão de crédito";
          } else {
            errorPaymentMethodString += paymentMethod.name.toLowerCase();
          }

        } else if (paymentMethod.name === "Cartão de crédito_ADYEN") {
          errorPaymentMethodString += " ou " + "cartão de crédito";
        } else {
          if (paymentMethod.name === "Pix") {
            errorPaymentMethodString += " ou " + paymentMethod.name;
          } else {
            errorPaymentMethodString += " ou " + paymentMethod.name.toLowerCase();
          }
        }
      });

      return "Cupom válido somente para " + errorPaymentMethodString;
    }


  }

  update() {

    this.cart = this.cartService.getCurrentCart();
    if (this.cart) {
      const ccCart = this.cartService.getCartByPaymentMethod("CREDIT_CARD");

      if (ccCart) {
        this.installments = this.cart.getInstallmentsByIdentifier(
          this.lastPaymentOption
        );
      }


      // this.installments = this.cart.getInstallmentsByIdentifier('CREDIT_CARD');
      this.sessionStorageService.setClassification(
        this.cart.product.classificationIdentifier
      );
      this.sessionStorageService.setClassificationName(
        this.cart.product.classificationName
      );

      this.currentPaymentMethod = this.cart.paymentMethod.identifier;
      this.isBankBillet = this.cart.paymentMethod.identifier === "BANK_BILLET";
      this.isPix = this.cart.paymentMethod.identifier === "PIX";

      if (!this.isHasValidAppliedCoupon()) {
        this.cart.couponIdentifier = this.couponIdentifier;
        this.couponIsInvalid = true;
        this.getCartErrors();
      }

      // if(!this.sessionStorageService.getCoupon()){
      //   this.sessionStorageService.setCoupon(this.cart.couponIdentifier);
      // }  

      if (this.cart.couponIdentifier && this.isHasValidAppliedCoupon()) {
        this.couponFb.controls.couponIdentifier.disable();
        this.couponIsInvalid = false;
      } else {
        if (this.cartErrorShown) this.invalidCoupon = false;
        if (!this.cart.couponIdentifier) {
          this.couponFb.controls.couponIdentifier.enable();
        }


        // if (! this.isHasValidAppliedCoupon()) {]
        // manter para caso tenha problemas com o cupom
        //   this.sessionStorageService.clearSessionStorage(["coupon"]);
        //   this.couponIdentifier = "";
        //   this.couponIsInvalid = true;
        // }

      }

      this.cart.validationData = this.sessionStorageService.getValidationData();

      this.changeDetectorRef.detectChanges();

      this.classificationIdentifier = this.sessionStorageService.getClassification(this.route);

      if (sessionStorage.getItem("isAplicarButton") && sessionStorage.getItem("isAplicarButton") === "true" && this.cart.couponIdentifier) {
        this.isAplicarButton = true;
      } else if (this.cart.couponIdentifier === "") {
        this.isAplicarButton = false;
      }
    }
    this.checkForExtraBalanceCoupon();
    this.checkForTrialCoupon();
  }

  onAutomaticRechargeClick(event, autoToggle = false) {
    this.allowAutomaticRecharge = event.checked;

    if (!this.isBankBillet && !this.isPix || (this.isBankBillet && this.allowAutomaticRecharge) || (this.isPix && this.allowAutomaticRecharge)) {
      this.lastAutomaticRechargeValue = event.checked;
    }
    // Se o produto so permite venda com recarga automatica
    if (this.cart && this.cart.product && this.cart.product.automaticRechargeOnly) {
      this.allowAutomaticRecharge = true;
      this.showAutomaticRechargeOnlyMessage = true;
      if (!autoToggle) this.dtmService.customClickEvent("Recarga Garantida", "Tentativa de desativação, porém produto só é vendido com recarga ativa.");
      // Da um timeout de 400ms para que o toggle seja reativado automaticamente
      setTimeout(() => {
        this.automaticRechargeFormControl.setValue(true);
      }, 400);
    } else {
      // Esta era a unica linha neste if-else
      // se formos remover essa funcionalidade, pode deixar so ela
      if (!autoToggle) this.dtmService.customClickEvent("Recarga Garantida", (this.allowAutomaticRecharge ? "Ativação" : "Desativação") + " da recarga.");
      this.allowAutomaticRechargeChange.emit(this.allowAutomaticRecharge);
    }

    if (this.cart && this.cart.validationData) {
      this.cart.validationData.allowAutomaticRecharge = this.allowAutomaticRecharge;
    }

    // Atualiza validationData no sessionStorage, para simulacao
    this.sessionStorageService.setValidationData({
      "byParameter": {
        "allowAutomaticRecharge": this.allowAutomaticRecharge
      }
    });

    // Chama o simulate apenas se o botão de toggle foi acionado manualmente
    if (!autoToggle) {
      if (!this.cart.product.automaticRechargeOnly) {
        let anyValidDiscount = this.cartService.anyCartHasValidAppliedCoupon();

        this.simulateCart(mapCurrentStep(), true, anyValidDiscount);
      }
    }
    this.checkForExtraBalanceCoupon();
  }

  activateAutomaticRecharge(keepCoupon?: boolean) {
    this.allowAutomaticRecharge = true;
    this.allowAutomaticRechargeChange.emit(this.allowAutomaticRecharge);
    if (this.cart && this.cart.validationData) {
      this.cart.validationData.allowAutomaticRecharge = this.allowAutomaticRecharge;
    }
    this.sessionStorageService.setValidationData({
      "byParameter": {
        "allowAutomaticRecharge": this.allowAutomaticRecharge
      }
    });
    // Remove o cupom aplicado no carrinho, caso exista
    if (this.cart.hasValidAppliedCoupon && !keepCoupon) {
      this.removeCoupon();
    } else {
      this.simulateCart(mapCurrentStep());
    }
    this.checkForExtraBalanceCoupon();
  }

  updateCoupon(saleStep: string, disableCouponField?: boolean, automaticRechargeChange?: boolean) {
    // TODO - pensar numa solucao melhor pra esse booleano do parametro
    this.cartErrors = [];
    this.submittingCouponCode = disableCouponField && disableCouponField === true;

    const couponIdentifier = this.cart.couponIdentifier;
    const productIdentifier = this.sessionStorageService.getProduct();
    this.cartService.setCart(this.cart);

    this.additionalData = this.sessionStorageService.getAdditionalData();

    this.cartService
      .simulate(this.cart._id, this.cart.type, productIdentifier, saleStep, [couponIdentifier],
        null, null, null, this.additionalData).subscribe(
          (simulatedCarts) => {
            this.cartService.setCarts(simulatedCarts);
            this.cartUpdated.emit(true);

            const currentPaymentMethod = this.cart.paymentMethod.identifier;
            this.cartService.setCartByPaymentMethod(currentPaymentMethod);
            this.cart = this.cartService.getCurrentCart();
            // Valida se algum cupom foi aplicado com sucesso no carrinho


            this.cart.hasValidAppliedCoupon = this.isHasValidAppliedCoupon();


            if (this.cart.hasValidAppliedCoupon) {
              this.dtmService.customClickEvent("CupomAplicado");
              if (!automaticRechargeChange) {
                this.snackBarService.openSnackBar("Cupom aplicado");
              }

              this.sessionStorageService.setCoupon(this.cart.couponIdentifier);
              this.couponFb.controls.couponIdentifier.disable();
              this.cartService.couponUpdated.next(true);
            } else if (
              !this.cart.hasValidAppliedCoupon &&
              this.couponAppliedManually
            ) {

              this.sessionStorageService.setCoupon(this.couponIdentifier);
              this.cartService.couponUpdated.next(true);
              this.dtmService.customClickEvent("CupomInvalido");
              this.invalidCoupon = true;
              this.cartErrorShown = false;
              this.couponFb.controls.couponIdentifier.disable();
              this.couponAppliedManually = false;
              this.getCartErrors();
            } else {
              this.sessionStorageService.setCoupon("");
              this.snackBarService.openSnackBar("Cupom removido");
              this.dtmService.customClickEvent("CupomRemovido");
              this.cartService.couponUpdated.next(true);
              this.couponFb.controls.couponIdentifier.enable();
            }
            this.submittingCouponCode = false;
            this.update();
          },
          (error) => {
            this.showCustomError('cartIntegrationError', error);
          }
        );
    this.checkForExtraBalanceCoupon();
    this.checkForTrialCoupon();

  }

  simulateCart(saleStep: string, automaticRecharge?: boolean, anyValidDiscount?: boolean) {
    this.cartErrors = [];

    const anyCartCouponIdentifier = this.cartService.getAnyCartCouponIdentifier();
    const couponIdentifier = automaticRecharge ? anyValidDiscount ? anyCartCouponIdentifier : "" : this.cart.couponIdentifier;
    const productIdentifier = this.sessionStorageService.getProduct();
    this.additionalData = this.sessionStorageService.getAdditionalData();
    this.cartService.setCart(this.cart);
    this.cartService
      .simulate(this.cart._id, this.cart.type, productIdentifier, saleStep, [couponIdentifier],
        null, null, null, this.additionalData).subscribe(
          (simulatedCarts) => {
            this.cartService.setCarts(simulatedCarts);
            this.cartUpdated.emit(true);

            const currentPaymentMethod = this.cart.paymentMethod.identifier;
            this.cartService.setCartByPaymentMethod(currentPaymentMethod);
            this.cart = this.cartService.getCurrentCart();
            this.update();
          },
          (error) => {
            this.showCustomError("cartIntegrationError", error);
          }
        );
  }

  setCouponValidationData() {
    let customer = this.customerService.getCurrentCustomer();
    if (!customer) {
      customer = new Customer();
    }
    const provisioningParameters = customer.provisioningParameter;
    if (customer && this.cart) {
      this.cart.validationData = {
        cnpj: customer.cnpj,
        cpf: customer.cpf,
        email: customer.email,
        businessId: provisioningParameters.businessId || null,
        userId: provisioningParameters.userId || null,
        allowAutomaticRecharge: customer.provisioningParameter.allowAutomaticRecharge ?
          provisioningParameters.allowAutomaticRecharge === true : null,
      };
      this.sessionStorageService.setValidationData(this.cart.validationData);
      this.cartService.setCart(this.cart);
    }
  }

  validateValue() {
    const value = this.cart.totalValue;

    if (!isNaN(value)) {
      if (value >= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  // Handling Errors
  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;

    switch (customErrorKey) {
      case "cartIntegrationError":
        integrationErrorMessage = this.handleIntegrationError(integrationError);



        this.cartErrors.push(integrationErrorMessage.userMessage);

        this.cart.couponIdentifier = "";



        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      default:
        break;
    }

    this.submittingCouponCode = false;
  }

  paymentSelected(paymentMethod: string) {
    if (this.currentPaymentMethod !== paymentMethod) {
      this.currentPaymentMethod = paymentMethod;
      this.cartService.setCartByPaymentMethod(this.currentPaymentMethod);
      this.cartService.cartUpdated.next(true);
      this.update();

      this.isBankBillet = this.currentPaymentMethod === "BANK_BILLET";
      this.isPix = this.currentPaymentMethod === "PIX";
      let isCreditCardCart = this.currentPaymentMethod === "CREDIT_CARD";

      // Se o usuário seleciona a opção boleto ou pix, desabilita automaticamente a opção de recarga automática.
      if (this.isBankBillet || this.isPix) {
        this.onAutomaticRechargeClick({ "checked": false }, true);
      }
      // Se ele seleciona o método cartão de crédito, a opção recarga garantida retorna ao estado anterior selecionado pelo usuário.
      if (isCreditCardCart) {
        this.onAutomaticRechargeClick({ "checked": this.lastAutomaticRechargeValue }, true);
      }

      this.cartService.paymentOptionChanged.subscribe((event) => {
        if (event && this.cart) {
          this.installments = this.cart.getInstallmentsByIdentifier(event);
        }
      
      });
    }
  }

  handleIntegrationError(error: any): any {
    const resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status !== null && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url && error.url.substring(error.url.indexOf("/api/1"));
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint
          }:${JSON.stringify(resultError.errors)}:${JSON.stringify(
            resultError.warnings
          )}`;

        resultError.userMessage = error.error._messages[0].text;

        if (
          resultError.userMessage.indexOf("java") >= 0 ||
          resultError.userMessage.indexOf("Java") >= 0 ||
          resultError.userMessage.indexOf("Script") >= 0 ||
          resultError.userMessage.indexOf("script") >= 0 ||
          resultError.userMessage.indexOf("elastic") >= 0 ||
          resultError.userMessage.indexOf("Elastic") >= 0
        ) {
          resultError.userMessage = errorMapping["cartIntegrationError"];
        } else {
          resultError.userMessage = 'Ocorreu um erro ao processar sua solicitação. Por favor, tente novamente.'
        }
      }
    } catch (e) {
      resultError.errorString = JSON.stringify(error);
      resultError.userMessage = errorMapping["cartIntegrationError"];
    }

    return resultError;
  }

  checkForTrialCoupon() {
    this.appliedCoupons = [];
    this.filteredCoupons = [];
    this.trialCoupon = null;
    if (this.cart && this.cart.appliedDiscounts) {
      this.cart.appliedDiscounts.forEach(discount => {
        if (discount.type === "TRIAL") {
          this.trialCoupon = discount;
        } else {
          this.appliedCoupons.push(discount);
        }
      });
      this.filteredCoupons = this.appliedCoupons.filter(el => el.type !== 'EXTRA_BALANCE');
    }
  }

  formatCurrency(value: number | string): string {
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numericValue)) {
      return 'Valor inválido';
    }
    return numericValue.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  checkForExtraBalanceCoupon() {
    this.appliedCoupons = [];
    this.extraBalanceCoupon = [];
    this.extraBalanceSum = 0;

    if (this.cart && this.cart.appliedDiscounts) {
      this.cart.appliedDiscounts.forEach(discount => {
        if (discount.type === "EXTRA_BALANCE") {
          this.extraBalanceCoupon.push(discount);
        } else {
          this.appliedCoupons.push(discount);
        }
      });

    }

    if (this.extraBalanceCoupon.length > 0) {
      this.extraBalanceSum = this.extraBalanceCoupon.reduce((accumulator, discount) => {
        return accumulator + discount.extraBalance;
      }, 0);
    }
  }

  getPlanType() {
    let planType = this.cart.product.name.split("- ").pop();
    return planType;
  }

  changePlan() {
    this.dtmService.customClickEvent(
      'AlterarPlano'
    );
    this.utils.returnToShopWindow();
  }

  return() {
    window.location.href = this.redirectUrl;
  }

  automaticRechargeValueFormat() {
    let automaticRechargeValue = this.cart.product.automaticRecharge;
    return Number.isInteger(automaticRechargeValue) ? automaticRechargeValue : automaticRechargeValue.toFixed(2).replace('.', ',');
  }

  checkShowFormularyCoupon(cart: Cart) {

    if (cart && cart.appliedDiscounts && cart.appliedDiscounts.some(discount => discount.type === 'TRIAL' && discount.automaticDiscount)) {
      this.showFormularyCoupon = false;
      return false;
    }

    return true;
  }

  isHasValidAppliedCoupon(): boolean {
    let result;
    result = this.cart.couponIdentifier && this.cart.appliedDiscounts.length > 0 ? true : false;
    if (result) {
      result = this.cart.appliedDiscounts.some(discount => discount.identifier === this.cart.couponIdentifier);
    }

    this.couponIsInvalid = !result;
    
    return result;
  }
}

function mapCurrentStep() {
  const currentStep = sessionStorage.getItem('currentStep');
  if (currentStep) {
    switch (currentStep) {
      case '1':
        return 'PAYMENT';
      case '2':
        return 'SUCCESS';
      default:
        return 'PAYMENT';
    }
  }
}
